import React from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';
import { useBreakpointV2 } from '@helpers/use';

const EnrolledBox = () => {
  const { t } = useTranslation('store_course');
  const { isMobile } = useBreakpointV2();
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: { md: '24px', xs: '8px 16px' },
        display: 'flex',
        border: `1px solid ${theme.palette.textOnPrimary.disabled}`,
        borderRadius: '4px',
        gap: { md: '24px', xs: '8px' },
      }}
    >
      <FontAwesomeIcon style={{ fontSize: isMobile ? '24px' : '32px' }} icon="fa-light fa-graduation-cap" />
      <Box>
        <Typography variant={isMobile ? 'h6' : 'h4'}>
          {t('course_detail.header_banner.purchase.credit.title')}
        </Typography>
        {!isMobile && (
          <Typography variant="body1lanna">{t('course_detail.header_banner.purchase.credit.content')}</Typography>
        )}
      </Box>
    </Box>
  );
};

export default EnrolledBox;
